export interface JobPosting {
  title: string;
  description: string;
  requirements: string[];
  salary: string;
  salaryMin: number;
  salaryMax: number;
  datePosted: string;
  level: string;
  location: string;
  icon: string;
}

export const JOB_POSTINGS: JobPosting[] = [
  {
    title: 'Developer Advocate',
    description:
      "Join our team as a Developer Advocate and help developers build amazing mobile apps with our SDKs and services. You'll create content, speak at conferences, and engage with our developer community to drive adoption and success.",
    requirements: [
      'Interest in developer advocacy and community engagement',
      'Basic to intermediate technical background in mobile development (iOS/Android, React Native, or Capacitor)',
      'Strong communication skills and comfort with public speaking',
      'Experience or interest in creating technical content, tutorials, or documentation',
      'Passion for helping developers succeed and building communities',
      'Willingness to learn new technologies and frameworks',
    ],
    salary: '\u20AC50,000 - \u20AC70,000',
    salaryMin: 50_000,
    salaryMax: 70_000,
    datePosted: '2025-06-01',
    level: 'Junior to Mid-Level',
    location: 'Remote',
    icon: '@tui.megaphone',
  },
];
